module.exports = __webpack_public_path__ + "43b8efdfa922740a19fe899d9a1d9a90.svg";